<template>
	<a :href="'/users/' + id" @click.prevent="onLink" class="user-photo" :style="{width: width + 'px', height: height + 'px'}">
		<img v-if="source !== ''" :src="source" class="image-round" />
		<div v-if="source === ''" v-bind:style="{backgroundColor: color}" class="image-round user-photo__default"><span>{{ text }}</span></div>
	</a>
</template>
<script>
import stringtohexcolor from '@bezlepkin/stringtohexcolor'
export default {
	data () {
		return {
			source: '',
			color: '',
			text: ''
		}
	},
	props: {
		id: {
			type: Number,
			required: true
		},
		width: {
			type: Number,
			default: 40
		},
		height: {
			type: Number,
			default: 40
		},
		link: {
			type: Boolean,
			default: true
		}
	},
	created () {
		this.getUser()
	},
	methods: {
		getUser () {
			if (Object.keys(this.$store.state.userModule.users).length === 0) return ''
			const user = this.$store.state.userModule.users[this.id]
			const color = stringtohexcolor(user.first_name + ' ' + user.last_name)
			this.color = '#' + color.color
			this.text = color.string
			if (typeof user.photo === 'object') {
				this.source = user.photo.xs
			}
		},
		onLink () {
			if (this.link) this.$router.push('/users/' + this.id)
		}
	}
}
</script>
<style lang="scss">
.user-photo {
	display: block;
	width: 40px;
	height: 40px;
	margin: 0 !important;
	img {
		width: 100%;
		height: auto;
	}
	&:hover {
		text-decoration: none;
	}
}

.user-photo__default {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100% !important;
  height: 100%;
  color: #fff;
  text-transform: uppercase;
  font-size: 1.3em;
}
</style>



// WEBPACK FOOTER //
// src/components/user/user-photo.vue